import React from 'react'
import Language from '../lang.component'
import NavIcon from './navicon.component'

/**
 * Bootstrap styled navigation bar
 *
 * @author Pragya Gupta
 */

const brandLogo = '../images/invosy_logo.png'
const Navigation = () => (
  <header className="navbar">
    <div className="dashboard-header-insecure">
      <nav className="dashboard-header-brand">
        <div>
          <a href="https://www.invosy.com/fi">
            <img
              className="navbar-brand dashboard-nav-brand"
              src={brandLogo}
              style={{
                maxHeight: '4.5em',
                maxWidth: '13.5em',
                objectFit: 'cover'
              }}
            />
          </a>
        </div>
      </nav>
      <div className="nav navbar-nav pull-right">
        <ul className="nav nav-tabs">
          <li>
            <Language landingNav={true} />
          </li>
          <li>
            <a
              className="dashboard-nav-linklist"
              rel="noopener noreferrer"
              href="https://www.invosy.com/fi"
              target="_blank"
              style={{ padding: 10 }}
            >
              <NavIcon
                name="sign-out"
                size="2x"
                content="Etusivulle"
                userLogged={false}
              />
            </a>
          </li>
        </ul>
      </div>
    </div>
  </header>
)

export default Navigation
